import Layout from "../layouts/layout";
import styles from "../styles/_pages/orderDetails.module.scss";

const OrderDetails = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <h1>Order Details</h1>

          <form>
            {/* first name */}
            <div className={styles.field}>
              <label>First Name</label>
              <input type="text" />
            </div>
            {/* last name */}
            <div className={styles.field}>
              <label>Last name</label>
              <input type="text" />
            </div>
            {/* email */}
            <div className={styles.field}>
              <label>Email</label>
              <input type="email" />
            </div>
            {/* phone */}
            <div className={styles.field}>
              <label>Phone</label>
              <input type="number" />
            </div>

            <div className={styles.check}>
              <input type="checkbox" />
              <p>
                I would like to receive updates on new products and activities
              </p>
            </div>

            <div className={styles.check}>
              <input type="checkbox" />
              <p>I agree to the terms of use and cancellation policy</p>
            </div>

            <div className={`${styles.field} ${styles.coupon}`}>
              <label>Coupon Code</label>
              <input type="text" />
            </div>

            <p className={styles.total}>
              Total Cost: <span>$20</span>
            </p>

            <button>
              Submit
              <img src="/assets/upIcon2.svg" alt="chevron" />
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default OrderDetails;
